import { useMemo } from "react";

export default function useIsSale() {
    return useMemo(() => {
        const now = new Date();
        return now > new Date('2025-04-24T15:00:00') && now < new Date('2025-04-30T00:00:00')
    }, [])
}